import { useContext } from "react";
import { Grid, Stack, Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
//Srcs
import "./setting.scss";
import User from "../../Assets/icon_setting/add-user.png";
import Meeting from "../../Assets/icon_setting/meeting.png";
import Party from "../../Assets/icon_setting/networking.png";
import School from "../../Assets/icon_setting/school.png";
import BrandEngagement from "../../Assets/icon_setting/brand-engagement.png";
import councilPositions from "../../Assets/icon_setting/council-positions.png";
import Precinct from "../../Assets/icon_setting/precinct.png";
import Concept from "../../Assets/icon_setting/concept.png";
import { AuthContext } from "../../Context/AuthContext";

export default function Setting() {
  // Change Language
  const { t } = useContext(AuthContext);
  const SettingData = [
    {
      icon: <img alt="User icon" className="image" src={User} />,
      path: "/setting/user",
      title: t("page_user"),
      description: t("thead_description_user"),
    },
    {
      icon: <img alt="Member" className="image" src={Meeting} />,
      path: "/setting/member",
      title: t("page_member"),
      description: t("thead_description_member"),
    },
    {
      icon: <img alt="Party icon" className="image" src={Party} />,
      path: "/setting/party",
      title: t("page_party"),
      description: t("thead_description_party"),
    },
    {
      icon: <img alt="Party icon" className="image" src={councilPositions} />,
      path: "/setting/council-positions",
      title: t("page_council_positions"),
      description: t("thead_description_coucil_positions"),
    },
    {
      icon: <img alt="Meeting type icon" className="image" src={Meeting} />,
      path: "/setting/meeting-type",
      title: t("page_meeting_type"),
      description: t("thead_description_meetingtype"),
    },
    {
      icon: (
        <img
          alt="BrandEngagement icon"
          className="image"
          src={BrandEngagement}
        />
      ),
      path: "/setting/major",
      title: t("page_major"),
      description: t("thead_description_major"),
    },
    {
      icon: <img alt="School icon" className="image" src={School} />,
      path: "/setting/institute-or-university",
      title: t("page_institute_or_university"),
      description: t("thead_description_institute_or_university"),
    },
    {
      icon: <img alt="School icon" className="image" src={Precinct} />,
      path: "/setting/capital-province",
      title: t("page_province"),
      description: t("thead_description_province"),
    },
    {
      icon: <img alt="School icon" className="image" src={Concept} />,
      path: "/setting/reason-of-loss-member",
      title: t("page_reason_of_loss_member"),
      description: t("thead_description_reason_of_loss_member"),
    },
  ];

  return (
    <div className="setting-page">
      <Stack direction="row" spacing={1.7} className="page-header">
        <Stack direction="column" justifyContent="center">
          <Box className="slash" />
        </Stack>
        <Stack direction="column" justifyContent="center">
          <Typography className={t("class-page-title")}>{t("page_setting")}</Typography>
        </Stack>
      </Stack>

      <Box sx={{ mt: "30px" }}>
        <Grid container spacing={4}>
          {SettingData?.map((e, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={index}>
              <Link to={e?.path} style={{ textDecoration: "none" }}>
                <Stack
                  spacing={3}
                  direction="row"
                  alignItems="center"
                  className="setting-page-container"
                >
                  <Stack
                    direction="column"
                    className="page-image"
                    justifyContent="center"
                  >
                    {e?.icon}
                  </Stack>
                  <Stack direction="column">
                    <Typography className="page-title">{e?.title}</Typography>
                    <Typography className="page-description">
                      {e?.description}
                    </Typography>
                  </Stack>
                </Stack>
              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
}
